module.exports = __webpack_public_path__ + "img/HeaderCheckOut.31a0de01.jpg";